import { render, staticRenderFns } from "./AccountantsCommunicationMenu.vue?vue&type=template&id=59dc12ba&scoped=true&"
import script from "./AccountantsCommunicationMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsCommunicationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc12ba",
  null
  
)

export default component.exports